const initialFilterState = () => {
  return {
    startDate: null,
    endDate: null,
  };
};

export default initialFilterState;
